import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoBranch16 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M4.03174 14.235C2.86022 14.235 1.90985 13.2854 1.90967 12.1139C1.9098 11.207 2.47995 10.435 3.28076 10.1315V9.3717C3.28076 8.2002 4.23041 7.24988 5.40186 7.24963L10.2026 7.24963C10.5455 7.24942 10.8235 6.97144 10.8237 6.62854V5.86877C10.0227 5.56556 9.45278 4.79243 9.45264 3.88538C9.45277 2.71386 10.4032 1.76331 11.5747 1.76331C12.746 1.76366 13.6957 2.71407 13.6958 3.88538C13.6957 4.79274 13.125 5.56577 12.3237 5.86877L12.3237 10.1315C13.1248 10.4348 13.6957 11.2067 13.6958 12.1139C13.6956 13.2852 12.7459 14.2346 11.5747 14.235C10.4032 14.235 9.45282 13.2854 9.45264 12.1139C9.45276 11.207 10.0229 10.435 10.8237 10.1315V8.65686C10.6273 8.71693 10.4187 8.74959 10.2026 8.74963H5.40186C5.05883 8.74987 4.78076 9.02863 4.78076 9.3717V10.1315C5.58182 10.4348 6.1527 11.2067 6.15283 12.1139C6.15265 13.2852 5.20296 14.2346 4.03174 14.235ZM11.5747 4.50647C11.9175 4.50612 12.1956 4.22821 12.1958 3.88538C12.1957 3.5425 11.9175 3.26366 11.5747 3.26331C11.2316 3.26331 10.9528 3.54228 10.9526 3.88538C10.9528 4.22843 11.2316 4.50647 11.5747 4.50647ZM4.03174 12.735C4.37453 12.7346 4.65265 12.4567 4.65283 12.1139C4.65267 11.7733 4.37823 11.4968 4.03857 11.4928H4.02588C3.68532 11.4958 3.40983 11.7727 3.40967 12.1139C3.40985 12.4569 3.68864 12.735 4.03174 12.735ZM11.5747 12.735C11.9175 12.7346 12.1956 12.4567 12.1958 12.1139C12.1956 11.7733 11.9212 11.4968 11.5815 11.4928H11.5688C11.2283 11.4958 10.9528 11.7727 10.9526 12.1139C10.9528 12.4569 11.2316 12.735 11.5747 12.735Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoBranch16;